"use client";

import { useState } from "react";
import type { BaseTemplate } from "../../UniversalEntityPage/types";

/**
 * Consolidates all form state management into a single hook
 * Manages: template selection, active tab, error states, and success state
 */
export function useFormState() {
  // Template state
  const [selectedTemplate, setSelectedTemplate] = useState<BaseTemplate | null>(null);
  const [isSaveTemplateModalOpen, setIsSaveTemplateModalOpen] = useState(false);

  // Tab state
  const [activeTab, setActiveTab] = useState("form");

  // Error state for better error handling
  const [submissionError, setSubmissionError] = useState<string | null>(null);
  const [hasValidationErrors, setHasValidationErrors] = useState(false);
  const [isSuccessfullySubmitted, setIsSuccessfullySubmitted] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [manualErrorInfo, setManualErrorInfo] = useState<{
    count: number;
    fields: Array<{ fieldLabel: string; message: string; fieldName: string }>;
  } | null>(null);
  const [errorFieldNames, setErrorFieldNames] = useState<Set<string>>(new Set());

  // Submission state
  const [isCreating, setIsCreating] = useState(false);

  return {
    // Template state
    selectedTemplate,
    setSelectedTemplate,
    isSaveTemplateModalOpen,
    setIsSaveTemplateModalOpen,

    // Tab state
    activeTab,
    setActiveTab,

    // Error state
    submissionError,
    setSubmissionError,
    hasValidationErrors,
    setHasValidationErrors,
    isSuccessfullySubmitted,
    setIsSuccessfullySubmitted,
    showErrorPopup,
    setShowErrorPopup,
    manualErrorInfo,
    setManualErrorInfo,
    errorFieldNames,
    setErrorFieldNames,

    // Submission state
    isCreating,
    setIsCreating,
  };
}
